var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.661,
    height: 9.661,
    viewBox: "0 0 9.661 9.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M73.32,72.04l-3.285-3.285,3.285-3.285a.905.905,0,0,0-1.28-1.28l-3.285,3.285-3.285-3.285a.905.905,0,0,0-1.28,1.28l3.285,3.285L64.191,72.04a.905.905,0,0,0,1.28,1.28l3.285-3.285L72.04,73.32a.905.905,0,0,0,1.28-1.28Z",
    transform: "translate(-63.925 -63.925)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.2db6b0688aa015174bc78cd01519efd4.svg";
export { ForwardRef as ReactComponent };